import {
  GLYPHE,
  formaterMontant,
  formaterMontantDevise,
  formaterPerformance,
  formaterPoints,
  formaterPourcentage,
  montant,
  sensVariation,
  type Numerique,
} from '@gsm/partage';

/**
 * Affichage d'une valeur numérique (charte, doc 06, § 5).
 *
 * Aucun composant ne formate un nombre lui-même : tout passe par ici, donc
 * par le module de formatage unique. C'est ce qui garantit qu'un montant a
 * la même apparence dans un tableau, une fiche et un PDF.
 */

type Nature = 'montant' | 'devise' | 'pourcentage' | 'performance' | 'points';

const FORMATEURS: Record<Nature, (v: Numerique) => string> = {
  montant: formaterMontant,
  devise: (v) => formaterMontantDevise(v),
  pourcentage: (v) => formaterPourcentage(v),
  performance: (v) => formaterPerformance(v),
  points: (v) => formaterPoints(v),
};

export function Nombre({
  valeur,
  nature = 'montant',
  colorer = false,
}: {
  valeur: Numerique;
  nature?: Nature;
  /**
   * Colore selon le sens de la variation. Réservé aux données de
   * performance : le vert et le rouge ne décrivent jamais l'interface.
   */
  colorer?: boolean;
}) {
  const rendu = FORMATEURS[nature](valeur);

  if (!colorer) return <span className="n">{rendu}</span>;

  const sens =
    valeur === null || valeur === undefined || valeur === ''
      ? 'nul'
      : sensVariation(montant(valeur));

  return (
    <span className={`n ${sens}`}>
      {/* Le signe et le glyphe portent l'information : la couleur seule ne
          suffit jamais (charte, § 5). */}
      {sens !== 'nul' && <span aria-hidden="true">{GLYPHE[sens]} </span>}
      {rendu}
    </span>
  );
}
